var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15h-2.25v-1.5H21V3H10.5v2.25H9V3a1.502 1.502 0 011.5-1.5H21A1.502 1.502 0 0122.5 3v10.5A1.502 1.502 0 0121 15zM12.75 16.5V15h-3v-1.5H12V12H9.75v-1.5h-1.5V12H6v1.5h2.25V15h-3v1.5h3V18H6v1.5h6V18H9.75v-1.5h3z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5H3A1.502 1.502 0 011.5 21V9A1.502 1.502 0 013 7.5h12A1.502 1.502 0 0116.5 9v12a1.502 1.502 0 01-1.5 1.5zM3 9v12h12V9H3z",
    fill: "#45464F"
  })));
}
export default SvgStudyView;